module.exports = __webpack_public_path__ + "static/media/folder.b64bf211.svg";